var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPytest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.512 30.398h61.304a3.006 3.006 0 010 6.012H31.512a3.007 3.007 0 01-3.004-3.004 3.008 3.008 0 013.004-3.008zm0 0",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.047 24.32H44.37v2.844H32.047zm0 0",
    fill: "#009fe3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.168 24.32h12.324v2.844H48.168zm0 0",
    fill: "#c7d302"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.07 24.32h12.328v2.844H64.07zm0 0",
    fill: "#f07e16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.91 24.32h12.324v2.844H79.91zm0 15.22h12.324v20.835H79.91zm0 0",
    fill: "#df2815"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.07 39.54h12.352v33.847H64.07zm0 0",
    fill: "#f07e16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.168 39.54h12.324v50.698H48.168zm0 0",
    fill: "#c7d302"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.047 39.54H44.37v61.792H32.047zm0 0",
    fill: "#009fe3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytest);
export default __webpack_public_path__ + "static/media/pytest.9f9e1bb89bf1947bc7949cb585c225f5.svg";
export { ForwardRef as ReactComponent };